import type { Schema_Wohnsituation } from 'cpool-schemas';
import { Anschrift } from 'cpool-schemas';

import type { CreateApplicantFormValues } from './schemaCreateApplicantForm';

const prepareAnschrift = (anschrift: Schema_Wohnsituation['anschrift']) => {
    if (!anschrift) {
        return Anschrift.parse({});
    }

    return Anschrift.parse(anschrift);
};

export const mapMainApplicantWohnsituation = (
    livingSituation: Schema_Wohnsituation,
): CreateApplicantFormValues['wohnsituation'] => {
    const { anschrift, vorherigeAnschrift, ...rest } = livingSituation;

    return {
        ...rest,
        anschrift: prepareAnschrift(anschrift),
        gemeinsamerHaushalt: true,
        vorherigeAnschrift: prepareAnschrift(vorherigeAnschrift),
    };
};
